module.exports = __webpack_public_path__ + "img/mode_outline_3.84138c42.png";